import React from 'react';
import moment from 'moment';
import ModalWrapper from '../../helpers/modalWrapper';
import { SIZE_LG, MOMENT_DATE_TIME_FORMAT } from '../../helpers/constants';
import CONTENT_STRINGS from '../../helpers/contentStrings';
import SharedStep6 from './WizardSteps/sharedStep6';

const ApplicationPremiumSettingsRevisionsModal = (props) => {
    const {
        isOpen,
        onClose,
        revision,
        revisionTableProps,
        isPercentagePremium,
        appPremiumSettingsIndicator,
        isApplicationPremium,
        appPremiumSettingsHistoryItemData,
        revisionIndex,
        appPremiumSettingsHighlightedFields,
        appPremiumSettingsEmphasizedFields,
    } = props;

    if (!revisionTableProps) return null;

    const { limitOfIndemnity, notes, comments, endorsements, createdDate, revisionDate } = revision;
    const { columns, groups, verticalHeaders, topHeader, outerVerticalHeaders } = revisionTableProps;

    return (
        <ModalWrapper
            isOpen={isOpen}
            onClose={onClose}
            size={SIZE_LG}
            title={`${CONTENT_STRINGS.PREVIOUS_APPLICATION_PREMIUM_SETTING} — ${moment(revisionDate ?? createdDate).format(MOMENT_DATE_TIME_FORMAT)}`}
            modalTestId={'application-premium-history-modal'}
            buttonTestId={'close-modal'}
        >
            <SharedStep6
                currentStep={6}
                showTable={true}
                isApplicationPremium={isApplicationPremium}
                isPercentagePremium={isPercentagePremium}
                limitOfIndemnity={limitOfIndemnity}
                notes={notes}
                comments={comments}
                endorsements={endorsements}
                recoverableRatePercentage={revision.recoverableRatePercentage ?? ''}
                displayedCoverageType={revision.coverageOptionName || ''}
                displayedDeductible={revision.deductibleOptionName || ''}
                displayedEndorsement={revision.endorsementOptionName || ''}
                columns={columns}
                data={appPremiumSettingsHistoryItemData}
                groups={groups}
                verticalHeaders={verticalHeaders}
                topHeader={topHeader}
                outerVerticalHeaders={outerVerticalHeaders}
                stepMessages={[]}
                badResponseMsg={''}
                appPremiumSettingsIndicator={appPremiumSettingsIndicator}
                loiTestId={`application-premium-loi-history-${revisionIndex}`}
                notesTestId={`application-premium-notes-history-${revisionIndex}`}
                commentsTestId={`application-premium-comments-history-${revisionIndex}`}
                endorsementsTestId={`application-premium-endorsements-history-${revisionIndex}`}
                tableTestId={`application-premium-table-history-${revisionIndex}`}
                coverageTestId={`application-premium-coverage-history-${revisionIndex}`}
                deductiblesTestId={`application-premium-deductible-history-${revisionIndex}`}
                highlightedFields={appPremiumSettingsHighlightedFields}
                emphasizedFields={appPremiumSettingsEmphasizedFields}
            />
        </ModalWrapper>
    );
};

export default ApplicationPremiumSettingsRevisionsModal;
